/**
 * Caminhos da Realização Destaque usados fora da página. `ROTA_DA_APRECIACAO` é o mesmo valor do `APRECIACAO_ROOT`
 * da fila (`ApreciarRealizacao/shared/eligibility.ts`): a fila do gestor continua em `/minha-equipe` (pedido do
 * usuário, 07/10/2026).
 */
export const ROTA_DA_APRECIACAO = '/minha-equipe/validar-apreciar-realizacao';

/** Visão de participações do gestor a partir da fila (RDN-52). */
export const ROTA_DAS_PARTICIPACOES_DO_GESTOR = '/realizacao-destaque?vista=participacoes';
